export default "__VITE_ASSET__DWkWcjto__"